import { Link, Text, View } from '@react-pdf/renderer';
import logo from '@ui/assets/images/HPC/HELICAL_PRODUCTS_RGB_PRIMARY_LOGO_AW.png';
import { EnvConfig } from '@ui/config/env';

import { usePDFContext } from '../PDFProvider';
import { EmployeeInformation } from './components/EmployeeInformation';
import { Header } from './components/Header';
import { Logo } from './components/Logo';
import { Page } from './components/Page';
import { CustomerAddress } from './components/QuoteDetails/CustomerAddress';
import { CustomerContact } from './components/QuoteDetails/CustomerContact';
import { QuoteDetails } from './components/QuoteDetails/QuoteDetails';
import { QuoteInformation } from './components/QuoteDetails/QuoteInformation';
import { QuoteId } from './components/QuoteId';
import { QuoteLine } from './components/QuoteLine';
import { PartDescription } from './components/QuoteLine/PartDescription';
import { PartId } from './components/QuoteLine/PartId';
import { PartSpecs } from './components/QuoteLine/PartSpecs';
import { SiteInformation } from './components/SiteInformation';
import { Specs } from './components/Specs';
import { styles } from './components/styles';

const HPC_SITE_INFORMATION = [
  '901 West McCoy Lane Page 01',
  'Santa Maria, CA 93456-1069',
  'Phone (805) 928 - 3851',
  'EMail sales@heli-cal.com',
];

export function HPCQuoteDocument() {
  const { quoteLines } = usePDFContext();

  return (
    <Page>
      <Header>
        <Logo
          source={logo}
          text="AS9100 Registered"
          // Extra styles can be added to fine tune the logo
          // extraStyles={[{ height: '42px' }]}
        />

        <SiteInformation name="Helical Products" items={HPC_SITE_INFORMATION} />

        {/* Some sites may have a different ecommerce site */}
        <QuoteId ecommerceUri={EnvConfig.getKey('MW_COMPONENTS_URI')} />
      </Header>

      <QuoteDetails>
        <CustomerAddress />

        <CustomerContact />

        <QuoteInformation showFOB />
      </QuoteDetails>

      {quoteLines.map((line) => {
        return (
          <QuoteLine key={line.id} {...line}>
            <PartId {...line.part} source={line.snapQuoteLineSource} />
            <PartDescription description={line.part.description} />

            <PartSpecs specs={line.specs} />
          </QuoteLine>
        );
      })}

      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={styles.textSmall}>*** Line-Item Policy *** </Text>
          <Text style={styles.textSmall}>
            Since Helical Products produces parts in lots for shipment rather
            than to inventory, volume pricing per line item is based on the
            quantity to be shipped together.
          </Text>
        </View>
      </View>

      <Specs />

      <EmployeeInformation />

      {/* The rest of this is completely custom per site */}

      <View style={styles.row}>
        <View style={styles.halfRow}>
          <Text style={[styles.textSmall, styles.bold]}>
            Minimum order $750.00
          </Text>
          <Text style={styles.textSmall}>
            ISO9001: 2015 & AS9100D Certified
          </Text>
          <Text style={styles.textSmall}>
            Source Inspection - if required - additional $465.00
          </Text>
        </View>
        <View style={styles.halfRow}>
          <Text style={[styles.textSmall, styles.bold]}>
            Cancellation fee may apply
          </Text>
          <Text style={styles.textSmall}>
            Certificate of Compliance is supplied with each shipment.
          </Text>
          <Text style={styles.textSmall}>
            Dimensional Inspection Report and/or First Article Inspection Report
            – if required – additional $175.00-$750.00
          </Text>
        </View>
      </View>
      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={[styles.textSmall, styles.bold]}>
            This quotation is made without benefit of reviewing any PO
            directions involving: dimensional or performance specifications,
            process directions, shipping requirements, QC clauses, or any other
            requirement that may additionally impact the cost of producingthe
            quoted product. If such direction occurs with your submission of a
            PO, Helical Products reserves the right to increasethe price of the
            quoted product to compensate for the added activity.
          </Text>
        </View>
      </View>
      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={styles.textSmall}>
            View Your Order Status & Tracking Online:
          </Text>
          <Text style={styles.textSmall}>
            For updates on your order status and tracking information, log in to
            your account on MWComponents.com using the same email address
            associated withyour order. Navigate to My Account, then select
            Orders. If you do not already have an account, you can create one.
            Orders associated with the accountemail address will automatically
            populate.
          </Text>
        </View>
      </View>
      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={styles.textSmall}>
            Standard terms and conditions can be found on
            <Link href="https://www.mwcomponents.com/mw-industries-terms-and-conditions">
              https://www.mwcomponents.com/mw-industries-terms-and-conditions
            </Link>
          </Text>
        </View>
      </View>
      <View style={styles.row}>
        <View style={styles.fullRow}>
          <Text style={[styles.textLarge, styles.bold, styles.textCenter]}>
            All parts are manufactured in the USA
          </Text>
        </View>
      </View>
    </Page>
  );
}
